<template>
    <v-container fluid class="ma-0 pa-0">
        <progress-overlay :Loading="Loading"></progress-overlay>
        <div class="filterContainerHeader">
            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" small icon @click="expandAll" v-show="checkIfPanelCollapsed()"><v-icon>add</v-icon></v-btn>
                </template>
                <span>Expand all filters.</span>
            </v-tooltip>
            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" small icon @click="collapseAll" v-show="checkIfPanelExpanded()"><v-icon>remove</v-icon></v-btn>
                </template>
                <span>Collapse all filters.</span>
            </v-tooltip>
            <v-btn small color="black" @click="applyFilters" :dark="yourDataFiltersApplied" :disabled="!yourDataFiltersApplied">
                Apply Selections
            </v-btn>
        </div>
        <v-divider></v-divider>
        <VuePerfectScrollbar style="height:80vh">
            <v-expansion-panels v-model="panel" multiple accordion>
                <v-expansion-panel v-for="(category,index) in Categories" :key="index">
                    <v-expansion-panel-header>
                        <span>
                            <strong>{{ category.categoryName }}</strong><br />
                            <span class="caption">Max Selections: {{category.maxSelection}}</span>
                        </span>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <v-list dense flat class="ma-0 pa-0">
                            <div v-if="category.controlType=='radio'">
                                <v-list-item-group>
                                    <v-list-item>
                                        <v-radio-group v-model="yourDataFilterRadios[index]">
                                            <v-radio v-for="keyval in category.keyValues"
                                                     :key="keyval.itemName"
                                                     :label="keyval.itemName"
                                                     :value="keyval.itemValue"
                                                     color="indigo"
                                                     @change="onCheckboxChange"
                                                     class="pa-0 ma-0"
                                                     :disabled="checkIfTrendDataSelected()"></v-radio>
                                        </v-radio-group>
                                    </v-list-item>
                                </v-list-item-group>
                            </div>
                            <!--<div v-else-if="category.controlType=='Switch'">
                                <v-switch v-for="keyval in category.keyValues" :key="keyval.itemName" class="ma-0 pa-0"
                                          v-model="test" :label="keyval.itemName" value="keyval.itemValue">
                                </v-switch>
                            </div>-->
                            <div v-if="category.controlType=='checkbox'">
                                <v-list-item-group class="ma-0 pa-0">
                                    <v-list-item v-for="keyval in category.keyValues" :key="keyval.itemName" class="ma-0 pa-0">
                                        <v-checkbox :label="keyval.itemName"
                                                    color="indigo"
                                                    v-model="keyval.isSelected"
                                                    @change="onCheckboxChange(category)"
                                                    :disabled='disabledFunc(category) && !keyval.isSelected' class="ma-0 pa-0"></v-checkbox>
                                    </v-list-item>
                                </v-list-item-group>
                            </div>
                        </v-list>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </VuePerfectScrollbar>
    </v-container>
</template>
<script>
    import { mapState } from 'vuex';
    import VuePerfectScrollbar from 'vue-perfect-scrollbar'
    import ProgressOverlay from '../_partial/ProgressOverlay'

    export default {
        components: {
            VuePerfectScrollbar,
            ProgressOverlay
        },
        data() {
            return {
                Loading: false,
                panel: [],
                filtersUpdated: false,
                modelRadios: [],
                isTrendSelected: false
            }
        },
        created() {
            var trendData = "Trend Data";
            var trendArray = this.Categories.filter(function (item) {
                return item.categoryName.toUpperCase() == trendData.toUpperCase();
            });

            if (trendArray != null && trendArray.length > 0) {

                var isSelectedArray = trendArray[0].keyValues.filter(function (item) {
                    return item.isSelected == true;
                });
                if (isSelectedArray != null && isSelectedArray.length > 0) {
                    this.isTrendSelected = true;
                }
                else {
                    this.isTrendSelected = false;
                }
            }
        },
        computed: {
            ...mapState({
                Categories: state => state.CategoriesStore.yourDatafilterCategories,
                yourDataFiltersApplied: state => state.CategoriesStore.yourDataFiltersApplied,
            }),
            yourDataFilterRadios: {
                get() {
                    return this.$store.state.CategoriesStore.yourDataFilterRadios;
                },
                set(newVal) {
                    this.$store.state.CategoriesStore.yourDataFilterRadios = newVal;
                }
            },
            modelYourDataFilters: {
                get() {
                    return this.$store.state.CategoriesStore.modelYourDataFilters;
                },
            }
        },
        methods: {
            disabledFunc: function (x) {
                var count = 0;
                x.keyValues.map(function (m) {
                    if (m.isSelected)
                        count = count + 1;
                });
                if (count >= x.maxSelection)
                    return true;
                else
                    return false;
            },

            checkIfTrendDataSelected() {
                if (this.isTrendSelected) return true;
                else return false;
            },

            onCheckboxChange(category) {
                var trendData = "Trend Data";
                if (category != null && category.categoryName != null && category.categoryName.toUpperCase() == trendData.toUpperCase()) {

                    var isSelectedArray = category.keyValues.filter(function (item) {
                        return item.isSelected == true;
                    });
                    if (isSelectedArray != null && isSelectedArray.length > 0) {
                        let trendArray =
                            this.Categories.map(function (l) {
                                let categoryName = l.categoryName
                                let displaySection = l.displaySection
                                let maxSelection = l.maxSelection
                                let CategoryId = l.CategoryId
                                let controlType = l.controlType

                                if (categoryName.toUpperCase() == "CONTRACTS") {
                                    maxSelection = 1;
                                }
                                return {
                                    categoryName: categoryName,
                                    displaySection: displaySection,
                                    maxSelection: maxSelection,
                                    CategoryId: CategoryId,
                                    controlType: controlType,
                                    keyValues: l.keyValues.map(function (l) {

                                        let isSelected = false;

                                        if (l.itemValue.toUpperCase() == "TRENDDATA-1") {
                                            isSelected = true;
                                        }
                                        return {
                                            itemName: l.itemName,
                                            itemValue: l.itemValue,
                                            sortOrder: l.sortOrder,
                                            isSelected: isSelected
                                        }
                                    })
                                }
                            });

                        this.isTrendSelected = true;
                        this.$store.state.CategoriesStore.yourDatafilterCategories = trendArray;
                        this.$store.state.CategoriesStore.yourDataFilterRadios = [];
                        // console.log(JSON.stringify(array));
                    }
                    else {

                        //this.$store.state.CategoriesStore.modelYourDataFilters = this.Categories;

                        let nonTrendArray =
                            this.Categories.map(function (l) {
                                let categoryName = l.categoryName
                                let displaySection = l.displaySection
                                let maxSelection = l.maxSelection
                                let CategoryId = l.CategoryId
                                let controlType = l.controlType

                                if (categoryName.toUpperCase() == "CONTRACTS") {
                                    maxSelection = 3;
                                }

                                return {
                                    categoryName: categoryName,
                                    displaySection: displaySection,
                                    maxSelection: maxSelection,
                                    CategoryId: CategoryId,
                                    controlType: controlType,
                                    keyValues: l.keyValues.map(function (l) {
                                        return {
                                            itemName: l.itemName,
                                            itemValue: l.itemValue,
                                            sortOrder: l.sortOrder,
                                            isSelected: false
                                        }
                                    })
                                }
                            });

                        this.isTrendSelected = false;
                        this.$store.state.CategoriesStore.yourDatafilterCategories = nonTrendArray;
                        //console.log(JSON.stringify(nonTrendArray));
                    }
                }
                else {
                    this.$store.state.CategoriesStore.modelYourDataFilters = this.Categories;
                    this.$store.state.CategoriesStore.yourDataFiltersApplied = true;
                }
            },
            applyFilters() {
                let selectedCategories = [];
                this.Categories.map((cat) => {
                    let selCategory = {
                        categoryName: cat.categoryName,
                        keyValues: []
                    };
                    let keyval = cat.keyValues.filter((data) => {
                        return data.isSelected == true;
                    })
                    if (keyval.length > 0) {
                        selCategory.keyValues = keyval;
                    }
                    this.yourDataFilterRadios.map((radio) => {
                        let keyval = cat.keyValues.filter((data) => {
                            return radio == data.itemValue && data.isSelected == false;
                        })
                        if (keyval.length > 0) {
                            selCategory.keyValues = keyval;
                        }
                    })
                    if (selCategory.keyValues.length > 0) {
                        selectedCategories.push(selCategory);
                    }
                })
                this.$store.dispatch('CategoriesStore/settblYourDataFilters', selectedCategories);
                var count = 0
                for (var k = 0; k < selectedCategories.length; k++) {
                    var dispPref = selectedCategories[k];
                    if (dispPref.categoryName == "Display Preferences") {
                        count = selectedCategories[k].keyValues.length;
                    }
                }

                var countContracts = 0
                for (var l = 0; l < selectedCategories.length; l++) {
                    let dispPref = selectedCategories[l];
                    if (dispPref.categoryName.toUpperCase() == "CONTRACTS") {
                        countContracts = selectedCategories[l].keyValues.length;
                    }
                }

                if (count == 0 && !this.isTrendSelected) {
                    this.$store.dispatch('AppStore/SetAlert', { alert: 'Please select Display Preferences or Trend Data!', isError: true })
                }
                else if (this.isTrendSelected && countContracts == 0) {
                    this.$store.dispatch('AppStore/SetAlert', { alert: 'Please select at least one Contract!', isError: true })
                }
                else {
                    this.$store.state.CategoriesStore.yourDataFiltersApplied = false;
                    this.Loading = true;
                    this.$store.dispatch('UserManagementStore/getUserClientDetails').then(() => {
                        this.$store.dispatch('YourDataStore/getChartDataBOB')
                            .then(() => {
                                this.Loading = false;
                            }).catch(error => {
                                this.Loading = false;
                                this.$store.dispatch('AppStore/SetAlert', { alert: error, isError: true })
                            })
                    }).catch(error => {
                        this.Loading = false;
                        this.$store.dispatch('AppStore/SetAlert', { alert: error, isError: true })
                    })
                }
            },
            expandAll() {
                this.panel = [];
                for (var i = 0; i < this.Categories.length; i++) {
                    this.panel.push(i);
                }
            },
            collapseAll() {
                this.panel = [];
            },
            checkIfPanelCollapsed() {
                var result = true;
                for (var i = 0; i < this.panel.length; i++) {
                    if (this.panel[i] == true) {
                        result = false;
                    }
                }
                return result;
            },
            checkIfPanelExpanded() {
                var result = false;
                for (var i = 0; i < this.panel.length; i++) {
                    if (this.panel[i] == true) {
                        return true;
                    }
                }
                return result;
            },
        }
    };
</script>
<style lang="scss">
    .disable-events {
        pointer-events: none
    }

    .scroll-area {
        position: absolute;
        margin: auto;
    }

    .drawer-menu--scroll {
        height: auto;
        overflow: auto;
    }

    /*.filter-list {
        max-height: 100vh;
    }*/
</style>
